import { createFileRoute, useSearch } from '@tanstack/react-router';
import { useTheme, useMediaQuery } from '@mui/material';
import { useCallback } from 'react';
import {
  ContainerSelectionArgs,
  ContainerTypeLegacy,
  GrainOperations,
  navigateTo,
  OperationsViewHeader,
  useAuth,
  useGetViewer,
  validateGrainBinSupportAccess,
} from '@amber-ui/core';

function GrainOperationsRoute() {
  const theme = useTheme();
  // down('md') = < 960px, matches AuthLayout's mobile_width definition (width === 'sm' || 'xs').
  // Previously used down('sm') || only('xs') which was < 600px — inconsistent with AuthLayout.
  const matchesMobile = useMediaQuery(theme.breakpoints.down('md'));
  const mobile_width = matchesMobile;

  const { viewer } = useGetViewer();
  // Read acct from URL search params (source of truth)
  const { acct } = useSearch({ strict: false }) as { acct?: string };
  const { account_id: session_account_id } = useAuth();
  const effectiveAccountId = acct || session_account_id || '';

  const goContainer = useCallback((selected: ContainerSelectionArgs) => {
    if (selected.container_type === ContainerTypeLegacy.bin) {
      navigateTo('/grain_bin/dashboard', selected);
    } else if (selected.container_type === ContainerTypeLegacy.barge) {
      navigateTo('/barge/dashboard', selected);
    } else if (selected.container_type === ContainerTypeLegacy.pile) {
      navigateTo('/pile/dashboard', selected);
    }
  }, []);

  if (!viewer) return null;

  // Access guard: redirect accounts without grain_bin_support
  const { account } = viewer;
  if (!validateGrainBinSupportAccess(account, viewer)) {
    return null;
  }

  return (
    <>
      {mobile_width && <OperationsViewHeader />}
      <GrainOperations
        account_id={effectiveAccountId}
        user_id={viewer.user_id}
        goContainer={goContainer}
      />
    </>
  );
}

export const Route = createFileRoute('/_auth/grain/operations/')({
  component: GrainOperationsRoute,
});
